import React from "react";
import "../Styles/Blockprofilelanding.css";

import meetingImg from "../assets/img1.png";
import hrLadyImg from "../assets/img2.png";

function Blockprofilelanding() {
  return (
    <>
      <div className="block-wrapper" id="Blockprofile">

        {/* SINGLE SECTION — both rows now live inside one container */}
        <section className="block-section container">

          {/* ---------- ROW 1: ABOUT ---------- */}
          <div className="row align-items-center block-row">
            <div className="col-lg-4 col-md-6 col-12 block-sub">
              <img
                src={meetingImg}
                alt="Team Meeting"
                className="image1"
              />
            </div>

            <div className="col-lg-7 col-md-12 col-12 block-text">
              <h3 className="block-heading">About Black Profile :</h3>
              <p>
                A Black Profile is an account status used in companies to show that a user’s
                access has been blocked, disabled, or made inactive.
                When an employee’s account is no longer available for use, when their permissions
                are removed, or when their login is temporarily stopped, the system marks their
                profile as a Black Profile.
              </p>
            </div>
          </div>

          {/* DIVIDER between the two blocks instead of a section gap */}
          <div className="block-divider"></div>

          {/* ---------- ROW 2: WHY IT HAPPENS ---------- */}
          <div className="row align-items-center flex-md-row flex-column-reverse block-row">
            <div className="col-lg-7 col-md-12 col-12 block-text">
              <h3 className="block-heading">Why does a Black Profile happen?</h3>

              <p> A profile may be set to Black for different reasons: The employee has left the company
                The employee has violated company rules or policies
                The account requires security checks or verification
                The login access is paused due to internal review
                The user's access needs to be restricted temporarily
                There is a change in employment status (inactive, suspended, on hold)</p>
            </div>

            <div className="col-lg-4 col-md-6 col-12 block-sub img-cont">
              <img
                src={hrLadyImg}
                alt="HR Staff"
                className="image2"
              />
            </div>
          </div>

        </section>

      </div>
    </>
  );
}

export default Blockprofilelanding;